import type { ProfileIdentity } from '@/types/user';

const PROFILE_IDENTITY_STORAGE_KEY = 'eklase:profileIdentity';

const readStoredProfileIdentity = (): ProfileIdentity | undefined => {
  const stored = sessionStorage.getItem(PROFILE_IDENTITY_STORAGE_KEY);

  if (!stored) {
    return undefined;
  }

  try {
    return JSON.parse(stored) as ProfileIdentity;
  } catch {
    return undefined;
  }
};

let profileIdentity: ProfileIdentity | undefined = readStoredProfileIdentity();

const profileIdentityListeners = new Set<() => void>();

export const setProfileIdentity = (identity: ProfileIdentity | undefined) => {
  profileIdentity = identity;
  profileIdentityListeners.forEach((listener) => listener());

  if (!identity) {
    sessionStorage.removeItem(PROFILE_IDENTITY_STORAGE_KEY);
    return;
  }

  sessionStorage.setItem(
    PROFILE_IDENTITY_STORAGE_KEY,
    JSON.stringify(identity),
  );
};

export const getProfileIdentity = (): ProfileIdentity | undefined =>
  profileIdentity;

let isLoggingOut = false;

export const startLogout = () => {
  isLoggingOut = true;
};

export const hasLogoutStarted = (): boolean => isLoggingOut;

window.addEventListener('pageshow', (event) => {
  if (event.persisted) {
    isLoggingOut = false;
  }
});

const profileStateResetHandlers = new Set<() => void>();

export const registerProfileStateReset = (reset: () => void) => {
  profileStateResetHandlers.add(reset);
};

export const resetProfileState = () => {
  profileStateResetHandlers.forEach((reset) => reset());
};

let authErrorHandler: (() => void) | undefined;

export const setAuthErrorHandler = (handler: (() => void) | undefined) => {
  authErrorHandler = handler;
};

export const handleAuthError = () => {
  authErrorHandler?.();
};

export const subscribeProfileIdentity = (
  listener: () => void,
): (() => void) => {
  profileIdentityListeners.add(listener);

  return () => {
    profileIdentityListeners.delete(listener);
  };
};
